
<template>
  <div>
    <!-- <v-card style="border-radius:12px">
      <v-card-title primary-title>
        <div class="title mb-0">Titulo</div>
      </v-card-title>
      <v-card-text>
        {{notification}}
      </v-card-text>
      <v-card-actions v-if='false' class="justify-end">
        <v-btn text color="error">Cancelar</v-btn>
        <v-btn text color="primary">OK</v-btn>
      </v-card-actions>
    </v-card> -->
    <v-list-item link 
      :to="{ ...getItemPath(notification) }" @click="readNotification(notification)"
    >
      <v-list-item-avatar>
        <v-icon 
          :class="[model[notification.notifiable_type].left_icon.bg_color,'']" 
          :color='model[notification.notifiable_type].left_icon.color'
        >
          {{model[notification.notifiable_type].left_icon.icon}}
        </v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{notification.parameters.title? notification.parameters.title : model[notification.notifiable_type].label}}</v-list-item-title>

        <v-list-item-subtitle>{{notification.parameters.text? notification.parameters.text : model[notification.notifiable_type].label}}</v-list-item-subtitle>
        <v-list-item-subtitle>
          <div class='caption'>
            <!-- <b> {{notification.parameters.notifier_name}}</b> - {{$moment(notification.created_at).locale('pt-BR').format('lll')}} -->
            <b> {{notification.parameters.notifier_name}}</b> - {{$moment(notification.created_at).locale('pt-BR').format('DD [de] MMM, HH:mm')}}
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-icon :color="model[notification.notifiable_type].right_icon[notification.parameters.kind || 'default' ].color || 'purple'">
          {{model[notification.notifiable_type].right_icon[notification.parameters.kind || 'default'].icon || 'mdi-check'}}
        </v-icon>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name:'NotificationCard',
  props: {
    notification: {
      type: Object,
    },
  },
  data() {
    return {
      key: null,
      model:{
        Task: {
          label: 'Tarefa',
          path:{ 
            name: 'Tasks',
            // params_key: 'id'
          },
          left_icon: {
            icon: 'mdi-calendar-check',
            color: 'info darken-5',
            bg_color: 'info lighten-4',
          },
          right_icon: {
            default:{
              icon: 'mdi-information',
              color: 'blue'
            },
            reminder:{
              icon: 'mdi-alarm',
              color: 'orange'
            },
            notification:{
              icon: 'mdi-information',
              color: 'blue'
            },
            alert:{
              icon: 'mdi-alert',
              color: 'amber'
            }
          }
        },
        ActionPlan: {
          label: 'Plano de Ação',
          path:{ 
            name: 'OneActionPlan',
            params_key: 'id'
          },
          left_icon: {
            icon: 'mdi-target',
            color: 'red darken-5',
            bg_color: 'red lighten-4',
          },
          right_icon: {
            default:{
              icon: 'mdi-information',
              color: 'blue'
            },
            reminder:{
              icon: 'mdi-alarm',
              color: 'orange'
            },
            notification:{
              icon: 'mdi-information',
              color: 'blue'
            },
            alert:{
              icon: 'mdi-alert',
              color: 'amber'
            }
          }
        },
        DataExport: {
          label: 'Exportação de dados',
          path:{ 
            name: 'DataExport',
            // params_key: 'id'
          },
          left_icon: {
            icon: 'mdi-file-excel',
            color: 'purple darken-5',
            bg_color: 'purple lighten-4',
          },
          right_icon: {
            default:{
              icon: 'mdi-information',
              color: 'blue'
            },
            reminder:{
              icon: 'mdi-alarm',
              color: 'orange'
            },
            notification:{
              icon: 'mdi-information',
              color: 'blue'
            },
            alert:{
              icon: 'mdi-alert',
              color: 'amber'
            }
          }
        }
      }
    }
  },
  methods: {
    getItemPath(item){
      let {name, params_key} = this.model[item.notifiable_type].path
      let params = {}
      params[params_key] = item.notifiable_id
      return {
        name,
        params
      }
    },
    readNotification(item){
      console.log('marcar com lido')
      this.readNotification(item)
    },
    ...mapActions({
      readNotification: 'Notification2/readNotification',
      // updateNotification: 'Notification2/update',
      showNotification: 'Notification2/show',
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>